<div class="search__top">
  <div class="search__top__field" role="banner">
    <h1 hidden>{{ 'tab.search' | translate }}</h1>
    <input
      [formControl]="searchControl"
      (focus)="startSearch()"
      type="search"
      placeholder="{{ 'search.placeholder' | translate }}"
      (keyup.enter)="hideKeyboard()"
      autocapitalize="none"
    />
    <span
      aria-hidden="true"
      inlineSVG="/assets/icons/navigation/search.svg"
      class="search-icon"
    ></span>
    <span
      (click)="closeSearch()"
      role="button"
      tabindex="0"
      divClickDirective
      inlineSVG="/assets/icons/close.svg"
      [attr.aria-label]="'button.close' | translate"
      class="close"
      *ngIf="isSearchVisible"
    ></span>
  </div>

  <div
    class="search__top__map"
    [class.active]="!isSearchVisible"
    [hidden]="isSearchVisible"
  >
    <app-map
      [zoom]="8"
      [padding]="{ top: 64 }"
      (mapLoaded)="mapLoaded($event)"
    ></app-map>
    <button
      *ngIf="mapFinishedLoading"
      [class.located]="hasUserLocation"
      class="search__top__map__locate"
      [attr.aria-label]="'button.locate_user' | translate"
      [inlineSVG]="'/assets/icons/crosshairs-gps.svg'"
      (click)="locateUser()"
    ></button>
  </div>

  <div class="search__top__overlay" [class.active]="isSearchVisible">
    <ion-content class="app search--search-results" *ngIf="isSearchVisible">
      <div class="search__top__overlay__inner">
        <div class="search__top__overlay__filters" *ngIf="showFilters">
          <span
            [hidden]="!location"
            tabindex="0"
            class="badge"
            role="button"
            [attr.aria-pressed]="isActive('distance')"
            [class.active]="isActive('distance')"
            (click)="switchFilter('distance')"
            >{{ 'projects.filter.title.nearby' | translate }}</span
          >
          <span
            tabindex="0"
            class="badge"
            role="button"
            [attr.aria-pressed]="isActive('created_at')"
            [class.active]="isActive('created_at')"
            (click)="switchFilter('created_at')"
            >{{ 'projects.filter.title.new' | translate }}</span
          >
          <span
            tabindex="0"
            class="badge"
            role="button"
            [attr.aria-pressed]="isActive('amount_of_followers')"
            [class.active]="isActive('amount_of_followers')"
            (click)="switchFilter('amount_of_followers')"
            >{{ 'projects.filter.title.popular' | translate }}</span
          >
        </div>
        <app-loader [loading]="searching"></app-loader>
        <app-search-item
          [detailsBlocked]="hideDetails"
          [loading]="!deviceDataLoaded"
          *ngFor="let project of searchResults"
          [withDistance]="location && hasUserLocation ? true : false"
          [project]="project"
        ></app-search-item>
        <p
          *ngIf="searchControl.value && searchResults.length == 0 && !searching"
          class="search__noResults"
        >
          {{ 'search.list.empty' | translate }}
        </p>
      </div>
    </ion-content>
  </div>
</div>
<ion-content class="app search--map-results" *ngIf="!isSearchVisible">
  <ion-progress-bar
    type="indeterminate"
    slot="fixed"
    *ngIf="searching"
  ></ion-progress-bar>
  <div
    *ngIf="totalItems !== undefined && allProjectsCount !== undefined"
    class="search-count-number"
  >
    <span>{{ totalItems }}</span>
    {{ 'search.results.number' | translate : { all: allProjectsCount } }}
  </div>
  <ngx-skeleton-loader
    *ngIf="undefined === totalItems"
    [theme]="{
      height: '0.875rem',
      width: '50%',
      display: 'block',
      margin: '20px auto'
    }"
  ></ngx-skeleton-loader>
  <div class="app__content">
    <div #searchResultElement class="search__results">
      <ng-container *ngIf="projectsLoaded">
        <app-search-empty
          *ngIf="projects?.length == 0 && projectsLoaded"
        ></app-search-empty>
        <app-search-item
          [detailsBlocked]="hideDetails"
          [loading]="!deviceDataLoaded"
          [withDistance]="location && hasUserLocation ? true : false"
          *ngFor="let project of projects"
          [project]="project"
        ></app-search-item>
        <ion-infinite-scroll
          *ngIf="location || bounds"
          [hidden]="projects?.length == totalItems"
          (ionInfinite)="loadData($event)"
        >
          <ion-infinite-scroll-content></ion-infinite-scroll-content>
        </ion-infinite-scroll>
      </ng-container>
      <app-loader [full]="false" [loading]="!projectsLoaded"></app-loader>
    </div>
  </div>
</ion-content>
